import React from 'react';

import { Product } from '@src/core/buyerApiClient';
import PlaceholderImage from '@src/components/ui2/PlaceholderImage';
import { Wrapper } from './styles';

interface Props {
  product: Product;
  showPlaceholderImage?: boolean;
  width?: string;
  height?: string;
  objectFit?: 'cover' | 'contain';
}

export const ProductImage = (props: Props) => {
  const { product, showPlaceholderImage = false, width = '80px', height = '80px', objectFit = 'contain' } = props;

  return (
    <>
      {product.thumbnailUrl ? (
        <Wrapper width={width} height={height}>
          <img src={product.thumbnailUrl} alt={product.name} style={{ objectFit }} />
        </Wrapper>
      ) : showPlaceholderImage ? (
        <Wrapper width={width} height={height}>
          <PlaceholderImage />
        </Wrapper>
      ) : null}
    </>
  );
};

export default ProductImage;
